const isRocket = process.env.CPA_ENV === 'rocket';

export default {
	baseURL: isRocket ? 'https://dashboard.rocketprofit.com' : 'https://dashboard.everad.com'
};



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/config/dashboard.js